module.exports = __webpack_public_path__ + "static/media/bulkreportNormal.4e70860c.svg";